<template>
  <div>
    <div
      class="w-full h-16 px-4 py-3 bg-white gap-4 flex justify-end items-center shadow-md"
    >
      <div v-if="isTimerActive" class="flex items-center gap-2">
        <img
          v-if="elapsedTimeOnlySeconds > 0"
          @click="stopTimer"
          src="/icons/global-timer/stop.svg"
          alt="Stop"
          class="w-6 h-6 cursor-pointer"
        />
        <img
          v-if="isPaused"
          @click="startTimer"
          src="/icons/nav-bar/play.svg"
          alt="Play"
          class="w-6 h-6 cursor-pointer"
        />
        <img
          v-else
          @click="pauseTimer"
          src="/icons/global-timer/pause_grey.svg"
          alt="Pause"
          class="w-6 h-6 cursor-pointer"
        />
        <div class="text-blue-700 text-sm font-medium">
          {{ formattedTime }}
        </div>
      </div>
      <button
        v-else
        @click="openStartModal"
        class="flex items-center gap-2 bg-slate-100 px-3 py-2 rounded-lg"
      >
        <img src="/icons/nav-bar/play.svg" class="w-5 h-5" alt="" />
        <span class="text-slate-500 text-sm font-medium">Time Tracker</span>
      </button>

      <div class="flex items-center gap-2">
        <button
          class="relative p-2 rounded-lg bg-slate-100"
          @click="toggleNotifications"
        >
          <img
            src="/icons/nav-bar/notification.svg"
            alt="Notifications"
            class="w-5 h-5"
          />
          <span
            v-if="unreadCount > 0"
            class="absolute top-0 right-0 translate-x-2 -translate-y-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full"
          >
            {{ unreadCount }}
          </span>
        </button>

        <ProfileMenu avatar-class="w-8 h-8" menu-class="w-36" />
      </div>
    </div>

    <NavBarModals
      v-model:start="showModalStart"
      v-model:stop="showModalStop"
      v-model:notifications="showNotifications"
    />
  </div>
</template>

<script>
import { useNavBarActions } from "@/composables/useNavBarActions";
import ProfileMenu from "./ProfileMenu.vue";
import NavBarModals from "./NavBarModals.vue";

// Barra superior móvil.
export default {
  components: { ProfileMenu, NavBarModals },
  setup() {
    return { ...useNavBarActions() };
  },
};
</script>
